// test2754
(2754 && 0);
